import { GraduationCap } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const trainingNav: NavEntry = {
  label: 'Training',
  icon: GraduationCap,
  path: '/training',
  permission: 'training:read',
  order: 23,
}
